/* Essence Elite, Warenkorb.

   Einzige Aufgabe: eine von Hand getippte Menge selbst uebernehmen, damit
   niemand erst „Warenkorb aktualisieren“ druecken muss. Wer das uebersieht,
   geht mit der alten Menge zur Kasse.

   Die Plus- und Minus-Tasten braucht diese Datei NICHT zu behandeln: Das
   Theme (assets/dT_shipping-cart.js) erhoeht dort den Wert und loest direkt
   danach selbst den Aktualisieren-Knopf aus. Nur das Tippen ins Feld blieb
   bisher ohne Wirkung.

   Verzoegerung von 700 ms, damit beim Tippen von „12“ nicht schon nach der
   „1“ abgeschickt wird.

   Die Klasse ee-js am <html> blendet den Aktualisieren-Knopf aus. Sie wird
   erst hier gesetzt, damit er ohne JavaScript stehen bleibt und der
   Warenkorb voll bedienbar ist. */
(function () {
  'use strict';

  var formular = document.querySelector('.main-cart-template form[action="/cart"]');
  if (!formular) return;

  document.documentElement.classList.add('ee-js');

  var uhr = null;
  var laeuft = false;

  formular.addEventListener('input', function (e) {
    if (!e.target || e.target.name !== 'updates[]') return;
    if (laeuft) return;
    clearTimeout(uhr);
    uhr = setTimeout(function () {
      laeuft = true;
      /* Ohne Namen abgeschickt: Shopify wertet updates[] aus und leitet
         zurueck auf /cart — dasselbe Verhalten wie der Aktualisieren-Knopf. */
      formular.submit();
    }, 700);
  });
})();
